<app-header-landing></app-header-landing>
<div id="main">
  <div class="section" id="section">
    <div id="message">
      <div class="title-container">
        <h2>{{ "message.title" | translate }}</h2>
      </div>

      <div style="text-align: center; margin-top: 20px">
        @if (!!datasource) {
          <p >
            {{ datasource | translate }}
          </p>
        } @else {
          <p>{{ "message.nodata" | translate }}</p>
        }
      </div>
    </div>
  </div>
</div>
